/* predictive search */
(function(){
const input=document.getElementById('search-input'), box=document.getElementById('predictive'), res=document.getElementById('predictive-results');
if(!input||!box)return;
const limit=window.ALW?.predictiveLimit||6;
let t;
input.addEventListener('input',()=>{
  clearTimeout(t);const q=input.value.trim();
  if(q.length<2){box.hidden=true;return;}
  t=setTimeout(async()=>{
    try{
      const r=await fetch(`/search/suggest.json?q=${encodeURIComponent(q)}&resources[type]=product&resources[limit]=${limit}`);
      const j=await r.json();const items=j.resources?.results?.products||[];
      if(!items.length){box.hidden=true;return;}
      res.innerHTML=items.map(p=>{const img=(p.featured_image&&p.featured_image.url)||p.featured_image||'';
        return `<a class="predictive__item" href="${p.url}">
        ${img?`<img src="${String(img).replace(/(\.[a-z]+)$/i,'_200x$1')}" alt="" loading="lazy">`:''}
        <span><span class="t">${p.title}</span><br><span class="p">${p.price}</span></span></a>`;}).join('');
      document.getElementById('predictive-all').href=`/search?type=product&q=${encodeURIComponent(q)}`;
      box.hidden=false;
    }catch{box.hidden=true;}
  },220);
});
document.addEventListener('click',e=>{if(!e.target.closest('.header-search'))box.hidden=true;});
input.addEventListener('keydown',e=>{if(e.key==='Escape')box.hidden=true;});
})();
